/* Who a square is for, by the booking and never by the person.
 *
 * Mangomint's "Walk In" is one client record shared by every walk-in the salon
 * has ever had — id 30525 had 338 appointments over 75 days by October 2026 —
 * so neither the client id nor the client name says which person a square is
 * for. The appointment id does: one appointment is one visit, however many
 * services are on it, and two walk-ins on the same afternoon are two
 * appointments.
 *
 * Two things here, both pure:
 *
 *   visitKey(turn)        what counts a client once. The appointment, else the
 *                         square itself — a square with no booking behind it is
 *                         somebody nobody wrote down, and the only safe count
 *                         for them is one each.
 *
 *   clientFromBooking(turn, appt)
 *                         what the square should say about its client now,
 *                         read off its own appointment. A walk-in is named
 *                         later, often after the square has finished, and the
 *                         edit that names them usually rewrites the service
 *                         lines too, so the square can no longer find its line.
 *                         It still has its appointment, and that is enough to
 *                         take the name from.
 */

export function visitKey(turn) {
  if (!turn) return null;
  if (turn.appointmentId != null && turn.appointmentId !== '') return 'a' + turn.appointmentId;
  return 't' + turn.id;
}

// { clientId, clientName } to write onto the square, or null when nothing
// changes. Only from the square's OWN appointment: anything else would be
// matching by who rather than by which booking.
export function clientFromBooking(turn, appt) {
  if (!turn || !appt || appt.id == null) return null;
  if (String(appt.id) !== String(turn.appointmentId)) return null;
  var out = { clientId: turn.clientId, clientName: turn.clientName };
  var changed = false;
  if (appt.clientId != null && appt.clientId !== turn.clientId) {
    out.clientId = appt.clientId;
    changed = true;
  }
  if (appt.clientName && appt.clientName !== turn.clientName) {
    out.clientName = appt.clientName;
    changed = true;
  }
  return changed ? out : null;
}
